import { StringExt } from '../util';
export class Registry {
    constructor(options) {
        this.options = Object.assign({}, options);
        this.data = this.options.data || {};
        this.register = this.register.bind(this);
        this.unregister = this.unregister.bind(this);
    }
    get names() {
        return Object.keys(this.data);
    }
    register(name, options, force = false) {
        if (typeof name === 'object') {
            Object.keys(name).forEach((key) => {
                this.register(key, name[key], options);
            });
            return;
        }
        if (this.exist(name) && !force && !Private.isApplyingHMR()) {
            this.onDuplicated(name);
        }
        const entity = this.options.process
            ? this.options.process.call(this, name, options)
            : options;
        this.data[name] = entity;
        return entity;
    }
    unregister(name) {
        const entity = name ? this.data[name] : null;
        delete this.data[name];
        return entity;
    }
    get(name) {
        return name ? this.data[name] : null;
    }
    exist(name) {
        return name ? this.data[name] != null : false;
    }
    onDuplicated(name) {
        try {
            // race
            if (this.options.onConflict) {
                this.options.onConflict.call(this, name);
            }
            throw new Error(`${StringExt.upperFirst(this.options.type)} with name '${name}' already registered.`);
        }
        catch (err) {
            throw err;
        }
    }
    onNotFound(name, prefix) {
        throw new Error(this.getSpellingSuggestion(name, prefix));
    }
    getSpellingSuggestion(name, prefix) {
        const suggestion = this.getSpellingSuggestionForName(name);
        const prefixed = prefix
            ? `${prefix} ${StringExt.lowerFirst(this.options.type)}`
            : this.options.type;
        return (
        // tslint:disable-next-line
        `${StringExt.upperFirst(prefixed)} with name '${name}' does not exist.` +
            (suggestion ? ` Did you mean '${suggestion}'?` : ''));
    }
    getSpellingSuggestionForName(name) {
        return StringExt.getSpellingSuggestion(name, Object.keys(this.data), (candidate) => candidate);
    }
}
(function (Registry) {
    function create(options) {
        return new Registry(options);
    }
    Registry.create = create;
})(Registry || (Registry = {}));
var Private;
(function (Private) {
    function getHMRStatus() {
        const mod = module;
        if (mod != null && mod.hot != null && mod.hot.status != null) {
            return mod.hot.status();
        }
        return 'unkonwn';
    }
    function isApplyingHMR() {
        return getHMRStatus() === 'apply';
    }
    Private.isApplyingHMR = isApplyingHMR;
})(Private || (Private = {}));
//# sourceMappingURL=registry.js.map